<template>
    <div class="text-right flex-shrink-0">
        <button v-on:click="onScan" class="btn btn-link text-success">{{ $t('events.scanticket') }}</button>
        <a class="btn btn-link text-secondary" :href="`/api/attendee/csv?event=${event._id }`">{{ $t('events.downloadlist') }}</a>
        <input type="file" ref="upload" class="d-none" @change="onTriggerUpload" accept=".csv">
        <button v-on:click="onUploadList" class="btn btn-link text-secondary">{{ $t('events.uploadlist') }}</button>
    </div>
</template>

<script>
    export default {
        props: [],
        computed: {
            event() {
                const id = this.$route.query.id;
                return this.$store.state.events.list.find(ev => ev._id === id);
            }
        },
        methods: {
            onScan: function () {
                this.$router.push({ path: 'events', query: { id: this.event._id, mode: 'scan' }});
            },
            onUploadList: function () {
                this.$refs.upload.click();
            },
            onTriggerUpload: function () {
                if (this.$refs.upload.files.length !== 1) return;
                this.$store.dispatch('uploadList', { id: this.event._id, file:  this.$refs.upload.files[0] })
            },
        },
    };
</script>